import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react'; // íconos
import logo from '../assets/vamosfusion.png';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <nav className="bg-[#0d2b66] text-white font-bold py-3">
      <div className="container mx-auto flex justify-between items-center px-4">
        
        {/* Logo */}
        <img src={logo} alt="Quimsa" className="h-10" />

        {/* Botón menú móvil */}
        <button
          className="md:hidden focus:outline-none"
          onClick={toggleMenu}
        >
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>

        {/* Menú desktop */}
        <ul className="hidden md:flex space-x-6 text-sm uppercase">
          <li><Link to="/">Inicio</Link></li>
          <li><Link to="/club">El Club</Link></li>
          <li><Link to="/equipo">El Equipo</Link></li>
          <li><Link to="/campeonatos">Campeonatos</Link></li>
          <li><Link to="/calendario">Calendario</Link></li>
          <li><Link to="/deportes">+Deportes</Link></li>
          <li><Link to="/tienda">Tienda</Link></li>
          <li><Link to="/acreditaciones">Acreditaciones 26/27</Link></li>
        </ul>
      </div>

      {/* Menú móvil desplegable */}
      {isOpen && (
        <ul className="md:hidden px-4 pt-4 pb-6 space-y-4 text-sm uppercase bg-[#0d2b66]">
          <li><Link to="/" onClick={toggleMenu}>Inicio</Link></li>
          <li><Link to="/club" onClick={toggleMenu}>El Club</Link></li>
          <li><Link to="/equipo" onClick={toggleMenu}>El Equipo</Link></li>
          <li><Link to="/campeonatos" onClick={toggleMenu}>Campeonatos</Link></li>
          <li><Link to="/calendario" onClick={toggleMenu}>Calendario</Link></li>
          <li><Link to="/deportes" onClick={toggleMenu}>+Deportes</Link></li>
          <li><Link to="/tienda" onClick={toggleMenu}>Tienda</Link></li>
          <li><Link to="/acreditaciones" onClick={toggleMenu}>Acreditaciones 26/27</Link></li>
        </ul>
      )}
    </nav>
  );
};

export default Navbar;
